<div class="fluid-container primary-content-container">
  <div class="outlet-content">

    <!-- Global Spinner -->
    <div class="spinner-overlay" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>

    <!-- Routed Pages -->
    <router-outlet></router-outlet>

  </div>
</div>

<!-- Global Dynamic Modal -->
<app-appmodal *ngIf="modalConfig"
              [title]="modalConfig.title"
              [bodyTemplate]="modalConfig.bodyTemplate"
              [footerTemplate]="modalConfig.footerTemplate"
              [size]="modalConfig.size || 'md'"
              [position]="modalConfig.position || 'center'"
              [animation]="modalConfig.animation || 'fade'"
              [drawer]="modalConfig.drawer || false"
              [width]="modalConfig.width"
              (close)="closeModal()">
</app-appmodal>

<!--<app-chat-widget *ngIf="isLoggedIn"></app-chat-widget>-->
<app-chat-widget *ngIf="isLoggedIn && !isCandidateLoginPage() && !isNormalLoginPage()">
</app-chat-widget>


